import { BaseApiModel } from 'app/models/api/response';

export class SensitivePhraseExclusion extends BaseApiModel {
    phrase?: string;
}
